import { apiV2, errorHandler } from "./index";
import {
  API_ERROR,
  UPLOAD_IMAGE,
  UPLOAD_IMAGE_TARGET,
  UPLOAD_AUDIO,
  UPLOAD_VIDEO,
  UPLOAD_MUX_VIDEO,
  CLEAR_MEDIA,
} from "../constants/ActionTypes";
import Swal from "sweetalert2";
import * as UpChunk from "@mux/upchunk";

//= ===============================
// Media actions
//= ===============================

export function uploadImage(file, target = "") {
  return function (dispatch) {
    Swal.fire({
      title: "Loading...",
      animation: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
    });

    var form = new FormData();
    form.append("file", file);

    return apiV2
      .post(`/resources/image/preview`, form)
      .then(response => {
        Swal.fire({
          title: "Image Uploaded",
          icon: "success",
          timer: 1000,
        });
        if (target !== "") {
          dispatch({
            type: UPLOAD_IMAGE_TARGET,
            payload: {
              image_url: response.data.image_url,
              target: target,
            },
          });
        } else {
          dispatch({
            type: UPLOAD_IMAGE,
            payload: response.data.image_url,
          });
        }
        return response;
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}

export function uploadCategoryImage(category_id, file) {
  return function (dispatch) {
    Swal.fire({
      title: "Loading...",
      animation: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
    });
    var form = new FormData();
    form.append("category_id", category_id);
    form.append("file", file);

    return apiV2
      .post(`/resources/image/preview`, form)
      .then(response => {
        Swal.fire({
          title: "Image Uploaded",
          icon: "success",
          timer: 1000,
        });
        dispatch({
          type: UPLOAD_IMAGE,
          payload: response.data.image_url,
        });
        return response;
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}
export function uploadAudio(file) {
  return function (dispatch) {
    Swal.fire({
      title: "Loading...",
      animation: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
    });

    var form = new FormData();
    form.append("file", file);

    return apiV2
      .post(`/resources/audio/preview`, form)
      .then(response => {
        Swal.fire({
          title: "Audio Uploaded",
          icon: "success",
          timer: 1000,
        });
        dispatch({
          type: UPLOAD_AUDIO,
          payload: response.data.audio_file_url,
        });
        return response;
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}

export function uploadVideo(file) {
  return function (dispatch) {
    Swal.fire({
      title: "Loading...",
      animation: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
    });

    var form = new FormData();
    form.append("file", file);

    return apiV2
      .post(`/resources/video/preview`, form)
      .then(response => {
        Swal.fire({
          title: "Video Uploaded",
          icon: "success",
          timer: 1000,
        });
        dispatch({
          type: UPLOAD_VIDEO,
          payload: response.data.video_url,
        });
        return response;
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}

export function uploadQuickTapVideo(file) {
  return async function (dispatch) {
    Swal.fire({
      title: "Loading...",
      animation: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
    });

    const form = new FormData();

    try {
      const response = await apiV2.get('/videos/quick-tap-upload-url');
      const { url, id: upload_id } = response.data;

      const upload = UpChunk.createUpload({
        endpoint: url,
        file,
        chunkSize: 5120, // Uploads the file in ~5mb chunks
      });

      // Subscribe to events
      upload.on("error", error => {
        console.error("uploading video error", error.detail);
        Swal.fire({
          title: "Upload Failed",
          text: error.detail || "Failed to upload video. Please try again.",
          icon: "error",
        });
      });

      upload.on("progress", progress => {
        Swal.update({ title: `Uploading... ${Math.round(progress.detail)}%` });
      });

      upload.on("success", async () => {
        try {
          Swal.update({ title: "Processing video..." });
          const response = await apiV2.get(`/videos/asset-data/${upload_id}`);
          const { playback_id, duration } = response.data;
          Swal.fire({
            title: "Video Uploaded",
            icon: "success",
            timer: 1000,
          });
          dispatch({
            type: UPLOAD_MUX_VIDEO,
            payload: {
              playback_id,
              duration,
            },
          });
        } catch (err) {
          Swal.fire({
            title: "Error",
            text: "Video uploaded but failed to get asset data.",
            icon: "error",
          });
        }
      });
    } catch (error) {
      const apiMessage = error?.response?.data?.message;
      Swal.fire({
        title: "Upload Failed",
        text: apiMessage || "Failed to get upload URL. Please try again.",
        icon: "error",
      });
      errorHandler(dispatch, error.response, API_ERROR);
    }
  };
}

export function clearMedia() {
  return function (dispatch) {
    dispatch({
      type: CLEAR_MEDIA,
    });
  };
}
